module.exports = __webpack_public_path__ + "img/瓯海区教育局拷贝@2x.e16b7578.png";